import React, { type MouseEvent, useState } from 'react';
import {
  ArrowDropDownIcon,
  Button,
  Menu,
  useConfirmationModal,
} from '@cherre-frontend/ui';
import { UploadPropertyButton } from '../../../Panels/PropertiesPanel/components/UploadPropertyButton';
import { ConfigureCustomAttributesButton } from './ConfigureCustomAttributesButton';

interface PropertiesActionsMenuButtonProps {
  onBulkUpload: ReturnType<typeof useConfirmationModal>['confirm'];
  onConfigureAttributes: () => void;
}

export const PropertiesActionsMenuButton = ({
  onBulkUpload,
  onConfigureAttributes,
}: PropertiesActionsMenuButtonProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const closeMenu = () => setAnchorEl(null);
  const openMenu = (event: MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget);

  const handleBulkUploadAndCloseMenu: typeof onBulkUpload = (params) => {
    onBulkUpload(params);
    closeMenu();
  };

  const handleConfigureAttributesAndCloseMenu = () => {
    onConfigureAttributes();
    closeMenu();
  };

  return (
    <>
      <Button
        color='primary'
        variant='contained'
        sx={{ marginTop: '12px' }}
        onClick={openMenu}
        startIcon={<ArrowDropDownIcon />}
      >
        Actions
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <UploadPropertyButton
          mode='bulk'
          variant='menu-item'
          confirmFunction={handleBulkUploadAndCloseMenu}
        />

        <ConfigureCustomAttributesButton
          variant='menu-item'
          onClick={handleConfigureAttributesAndCloseMenu}
        />
      </Menu>
    </>
  );
};
